import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

const SUPPORTED_LANGUAGES = ['fr', 'ar', 'es'];
const DEFAULT_LANGUAGE = 'fr';

export const useLanguage = () => {
  const { lang } = useParams();
  const navigate = useNavigate();
  const [currentLang, setCurrentLang] = useState(DEFAULT_LANGUAGE);

  // Vérifier si la langue est supportée
  useEffect(() => {
    if (!SUPPORTED_LANGUAGES.includes(lang)) {
      // Si la langue n'est pas supportée, rediriger vers la langue par défaut
      const currentPath = window.location.pathname;
      
      // Si le chemin ne commence pas par une langue valide, ajouter la langue par défaut
      if (!currentPath.startsWith('/fr') && !currentPath.startsWith('/ar') && !currentPath.startsWith('/es')) {
        const newPath = `/${DEFAULT_LANGUAGE}${currentPath}`;
        navigate(newPath, { replace: true });
      } else {
        // Si le chemin commence par une langue invalide, la remplacer
        const newPath = currentPath.replace(/^\/([^\/]+)/, `/${DEFAULT_LANGUAGE}`);
        navigate(newPath, { replace: true });
      }
      setCurrentLang(DEFAULT_LANGUAGE);
    } else {
      setCurrentLang(lang);
    }
  }, [lang, navigate]);

  // Fonction pour changer la langue
  const setLanguage = (newLang) => {
    if (SUPPORTED_LANGUAGES.includes(newLang)) {
      const currentPath = window.location.pathname;
      const newPath = currentPath.replace(/^\/(fr|ar|es)/, `/${newLang}`);
      navigate(newPath);
      setCurrentLang(newLang);
    }
  };

  // Obtenir la direction selon la langue
  const direction = currentLang === 'ar' ? 'rtl' : 'ltr';

  // Obtenir la police selon la langue
  const fontFamily = currentLang === 'ar' ? 'font-arabic' : 'font-default';

  return {
    lang: currentLang,
    direction,
    fontFamily,
    isRTL: currentLang === 'ar',
    setLanguage
  };
}; 